export const HK_getters = {
    // 获取香港开户的身份证信息
    getHK_IdCard(state) {
        return {
            nationality: state.nationality, // 国籍：2位国家码
            idType: state.idType, // 证件类型 : 1-身份证 Identity Card；2-护照 Passport；3-营业执照 Business Registration；4-签证 C.I.
            idCountry: state.idCountry, // 身份证所在国家，页面不展示，提供后台使用
            idNumber: state.idNumber, // 身份证号码
            documentInfo: state.documentInfo, // 图片等信息
            permanentResident: state.permanentResident,
            idExtraInfo: state.idExtraInfo,
        };
    },
    // 获取香港开户-用户信息
    getHK_userInfo(state) {
        return {
            chineseName: state.chineseName,
            firstName: state.firstName,
            lastName: state.lastName,
            gender: state.gender,
            birthday: state.birthday,
            birthCity: state.birthCity,
            birthCountry: state.birthCountry,
            email: state.email,
            defaultLanguage: state.defaultLanguage,
            clientInfo: state.clientInfo,
            nationality: state.nationality,
        };
    },
    // 香港开户-地址证明信息
    getHK_address(state) {
        return {
            contactInfo: state.contactInfo, // 地址相关的信息
            documentInfo: state.documentInfo, // 图片等信息
            w8Info: state.w8Info, // W8相关的信息
        };
    },
    // 香港开户是永居？
    isPermanentResident(state) {
        return state.permanentResident;
    },
    // 香港开户-开户状态
    getHK_AccountStatus(state) {
        return {
            status: state.applyStatus,
            cashInStatus: state.cashInStatus,
            cashInData: state.cashInData,
        };
    },
    // 香港开户获取驳回的信息
    getRejectData(state) {
        return state.rejectData;
    },
};
